import { lazy, Suspense } from 'react';
import { Redirect, Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import AntaresLanding from './pages/AntaresLanding';
import AnalyticsRuntime from './analytics/AnalyticsRuntime';
import CookieConsent from './components/CookieConsent';
const ExperienceTimeline = lazy(() => import('./pages/ExperienceTimeline'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'));
const FieldResearchPage = lazy(() => import('./pages/FieldResearchPage'));
const QRCodePage = lazy(() => import('./pages/QRCodePage'));
const AdminPesquisasPage = lazy(() => import('./pages/admin/AdminPesquisasPage'));
const AdminRegistrosPage = lazy(() => import('./pages/admin/AdminRegistrosPage'));
const AdminLeadsPage = lazy(() => import('./pages/admin/AdminLeadsPage'));
const AdminMetricsPage = lazy(() => import('./pages/admin/AdminMetricsPage'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));

function App() {
  return (
    <Router>
      <AnalyticsRuntime />
      <CookieConsent />
      <Suspense fallback={<div role="status">Carregando…</div>}>
      <Switch>
        <Route exact path="/" component={AntaresLanding} />
        <Route path="/qrcode" component={QRCodePage} />
        <Route path="/experience" component={ExperienceTimeline} />
        <Route path="/termos" component={TermsOfUse} />
        <Route path="/privacidade" component={PrivacyPolicy} />
        <Route path="/pesquisa-campo" component={FieldResearchPage} />
        <Route path="/admin">
          <AdminLayout>
            <Switch>
              <Route exact path="/admin"><Redirect to="/admin/metricas" /></Route>
              <Route path="/admin/metricas" component={AdminMetricsPage} />
              <Route path="/admin/pesquisas" component={AdminPesquisasPage} />
              <Route path="/admin/registros" component={AdminRegistrosPage} />
              <Route path="/admin/leads" component={AdminLeadsPage} />
            </Switch>
          </AdminLayout>
        </Route>
      </Switch>
    </Suspense>
    </Router>
  );
}

export default App;